export const getDays = (days: number, date = new Date()): Date => {
  const minDaysLeft = new Date(date).getDate() + days;
  const minDate = new Date(date).setDate(minDaysLeft);

  return new Date(minDate);
};
